const header = document.querySelector(".header-wrapper");
const heroLogo = document.querySelector(".animated-hero__logo");
const heroTitle = document.querySelector(".animated-hero__title");
const heroLink = document.querySelector(".animated-hero__link");

window.addEventListener("scroll", function (e) {
  if (window.scrollY > 5) {
    header.classList.add("header-anim");
    heroLogo.classList.add("logo-amin");
    heroTitle.classList.add("title-anim");
    heroLink.classList.add("link-anim");
  } else {
    heroLogo.classList.remove("logo-amin");
    header.classList.remove("header-anim");
    heroTitle.classList.remove("title-anim");
    heroLink.classList.remove("link-anim");
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById('animated-hero__video');
  const mobileVideo = document.getElementById('animated-hero__video-mobile');
  setTimeout(function() {      
      if (video) {
          video.play().catch(error => {
          });
      }
      
      if (mobileVideo) {
          mobileVideo.play().catch(error => {
          });
      }
  }, 1200);
});